import { Snackbar, Alert, Button, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";

let worker: ServiceWorker | null = null

export default function SW() {
    const { t } = useTranslation();
    const [update, setUpdate] = useState(false);

    const trackInstalling = (newWorker: ServiceWorker | null) => {
        if (newWorker) {
            worker = newWorker
            newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed') {
                    setUpdate(true)
                }
            });
        }
    }

    useEffect(() => {
        if (import.meta.env.PROD && 'serviceWorker' in navigator) {
            navigator.serviceWorker.register('/sw.js')
                .then(reg => {
                    if (!navigator.serviceWorker.controller) {
                        return; //first time that load service worker then user already has latest version
                    }

                    if (reg.waiting) {
                        worker = reg.waiting;
                        setUpdate(true);
                        return;
                    }

                    if (reg.installing) {
                        trackInstalling(reg.installing);
                        return;
                    }

                    reg.addEventListener('updatefound', () => {
                        trackInstalling(reg.installing)
                    })


                }).catch(e => {
                    console.error(e);
                });
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                window.location.reload();
            })
        }

    }, [])

    const handleUpdate = () => {
        worker?.postMessage({ action: 'skipWaiting' });
        window.location.reload();
    }

    const handleSnackbarClose = () => {
        setUpdate(false);
    }

    return (
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={update}>
            <Alert severity='success' action={<>
                <Button color="secondary" size="small" onClick={handleUpdate}>
                    {t('update_button')}
                </Button>
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={handleSnackbarClose}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </>}>
                {t('update_description')}
            </Alert>
        </Snackbar>
    );
}
